const topics = [
  { name: '恋爱甜宠', heat: '热', count: '1.2万讨论' },
  { name: '异世界转生', heat: '爆', count: '9.8千讨论' },
  { name: '校园青春', heat: '热', count: '8.5千讨论' },
  { name: '契约婚姻', heat: '新', count: '7.2千讨论' },
  { name: '复仇逆袭', heat: '热', count: '6.9千讨论' },
  { name: '超能力对决', heat: '', count: '5.4千讨论' },
  { name: '宫斗权谋', heat: '新', count: '4.8千讨论' },
  { name: '灵异恐怖', heat: '', count: '4.1千讨论' },
  { name: '治愈美食', heat: '', count: '3.6千讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          韩漫读者正在热议的话题标签，加入讨论发现同好
        </p>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-all duration-300 cursor-pointer group"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{topic.name}
              </span>
              {topic.heat && (
                <span className={`px-1.5 py-0.5 text-xs font-bold rounded whitespace-nowrap ${
                  topic.heat === '爆'
                    ? 'bg-primary-500 text-background-50'
                    : topic.heat === '热'
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-secondary-400 text-background-50'
                }`}>
                  {topic.heat}
                </span>
              )}
              <span className="text-xs text-foreground-400 whitespace-nowrap">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}